import { JourneysTransformer, EventTransformer, CollectionTransformer, MediaTransformer } from '@/transformers'
import { mapActions } from 'vuex'
import store from './../store'

const journeysTransformer = new JourneysTransformer()
const eventTransformer = new EventTransformer()
const collectionTransformer = new CollectionTransformer()
const mediaTransformer = new MediaTransformer()

export default {
    ...mapActions({
        addActiveJourney: 'trackingModule/addActiveJourney'
    }),

    transformJourneyRequest (journeyResponse, eventsResponse, mediaResponse, vehicle) {
        journeyResponse.payload.vehicle = vehicle
        //TODO: Aggragate data
        //TODO: Logic which joruney should be displayed
        const journeys = journeysTransformer.transform(journeyResponse.payload)
        const events = collectionTransformer.transform(eventTransformer, eventsResponse.payload.items)
        const eventsWithoutCategoryNone = events.filter(event => !event.eventCategories.includes(0))
        const medias = collectionTransformer.transform(mediaTransformer, mediaResponse.payload.items)
        const journeysList = this.getJourneyListToDisplay(journeys)
        this.matchMediasAndEventsWithJourney(journeysList, medias, eventsWithoutCategoryNone)

        journeys.medias = medias
        journeys.events = eventsWithoutCategoryNone

        store.dispatch('trackingModule/addActiveJourney', journeys)

        return journeys
    },

    isJourneyVehicleSubscribe (vehicle) {
        return null === this.findJourneyVehicle(vehicle)
    },

    findJourneyVehicle (vehicle) {
        const journeyVehicles = store.getters['trackingModule/getJourneyVehicles']

        return journeyVehicles.find((tmpVehicle) => {
            return tmpVehicle.id === vehicle.id
        })
    },

    findActiveJourney (vehicle) {
        const activeJourneys = store.getters['trackingModule/getActiveJourneys']

        return activeJourneys.find((journey) => {
            return journey.vehicle.id === vehicle.id
        })
    },

    getJourneyListToDisplay (journey) {
        let journeys = []
        if (null !== journey.currentJourney) {
            journeys.push(journey.currentJourney)
        }

        if (0 < journey.processedJourneys.length) {
            journeys.push(...journey.processedJourneys)
        }

        if (0 < journey.unprocessedJourneys.length) {
            journeys.push(...journey.unprocessedJourneys)
        }

        return journeys.sort((a, b) => new Date(b.startPoint.utc) - new Date(a.startPoint.utc))
    },

    matchMediasAndEventsWithJourney (journeyList, medias, events) {
        journeyList.forEach(journey => {
            const journeyStartDate = journey.startPoint.utc
            const journeyEndDate = journey.endPoint.utc
            journey.medias.push(...medias.filter(media => journeyStartDate <= media.createdOn && media.createdOn <= journeyEndDate))
            journey.events.push(...events.filter(event => journeyStartDate <= event.triggerOn && event.triggerOn <= journeyEndDate))
        })
    }

}
